/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Status enum for message
 */
export enum MessageStatusEnum {
  /**
   * Message exists but is not yet dispatched (outbound only)
   */
  DRAFT = "draft",

  /**
   * Message is queued for sending (outbound only)
   */
  QUEUED = "queued",

  /**
   * Message has left the system (outbound) OR
   * message has entered the system (inbound)
   */
  PROCESSED = "processed",

  /**
   * Message processing failed
   */
  ERROR = "error"
}
